import type { AuthType } from "../../auth/auth";
import { type Procedure, type ProcedureDetail } from "../core";

export const shouldAutomaticallySetGroupIdFromAuthCtx = (
  data: AuthType["data"],
): boolean => {
  if (!data) return false;

  if (data.accountType === "GrafferStaffAccount") return false;

  if (data.roles.includes("Admin")) return false;

  return data.groupIds.length === 1;
};

export const hasAccessFor = (
  data: AuthType["data"],
  procedure: Procedure | ProcedureDetail,
): boolean => {
  if (data?.accountType === "GrafferStaffAccount") return true;

  if (data?.accountType === "OrgAccount") {
    const { organizationId, groupId } = procedure.jurisdiction;

    if (data.orgId === organizationId) {
      if (data.roles.includes("Admin")) return true;

      if (
        !("groupId" in procedure.jurisdiction) ||
        groupId === undefined ||
        groupId === null ||
        groupId === ""
      ) {
        return (data.groupIds ?? []).length > 0;
      }

      return (
        typeof groupId === "string" && (data.groupIds ?? []).includes(groupId)
      );
    }
  }

  return false;
};
